import { useState, useEffect } from 'react';

import { NewsArticle } from '@/resources/NewsArticle';

import { useStores } from './useStores';

export function useInfiniteScroll(initalItems, initialNextItemsLink) {
  const { store } = useStores();

  const [isItemsLoading, setIsLecturesLoading] = useState(false);
  const [loadedItemsState, setLoadedLecturesState] = useState([]);
  const [itemsNext, setItemsNext] = useState(null);

  useEffect(() => {
    setItemsNext(initialNextItemsLink);
  }, [initialNextItemsLink]);

  useEffect(() => {
    setLoadedLecturesState(initalItems);
  }, [initalItems]);

  const onLoadMore = async () => {
    setIsLecturesLoading(true);

    const lecturesResponse = await store.request(decodeURIComponent(itemsNext));

    const loadedLectures = lecturesResponse.data as Array<NewsArticle>;

    setIsLecturesLoading(false);
    setLoadedLecturesState((prevState) => {
      if (prevState) {
        return [...prevState, ...loadedLectures];
      }
      return loadedLectures;
    });

    if (lecturesResponse.links.next) {
      setItemsNext(lecturesResponse.links.next);
    } else {
      setItemsNext(null);
    }
  };

  return {
    isItemsLoading,
    loadedItemsState,
    hasMore: Boolean(itemsNext),
    onLoadMore,
  };
}
